import type { CollapseProps } from "antd";

import BannerInfo from "./Info";
import BannerFiles from "./BannerFiles";
import BannerAddDetail from "./BannerDetail";


export const BannerDetailConstants = {
	EN: "Banner Detayları - İngilizce",
	TR: "Banner Detayları"
};

export const BannerConstants = {
	INFO: "Banner Özellikleri",
	BANNER_FILES: "Banner Resimleri",
	BANNER_LOCALIZABLE: BannerDetailConstants,
};

export const BannerItems: CollapseProps["items"] = [
	{
		key: "1",
		label: BannerConstants.INFO,
		children: <BannerInfo />,
	},
	{
		key: "2",
		label: BannerConstants.BANNER_FILES,
		children: <BannerFiles />,
	},
	{
		key: "3",
		label: BannerConstants.BANNER_LOCALIZABLE.TR,
		children: <BannerAddDetail Culture="tr-TR" />,
	},
	{
		key: "4",
		label: BannerConstants.BANNER_LOCALIZABLE.EN,
		children: <BannerAddDetail Culture="en-US" />,
	}
];


